import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { selectOptimizeExperimentMap } from 'root-redux/selects/common'
import { setOptimizeVariantMapAction } from 'root-redux/actions/common'

export const useSetOptimizeVariantMap = (): void => {
  const dispatch = useDispatch()
  const optimizeExperimentMap = useSelector(selectOptimizeExperimentMap)

  useEffect(() => {
    const setOptimizePageId = (abVariant, experimentId) =>
      dispatch(setOptimizeVariantMapAction({ abVariant, experimentId }))

    if (optimizeExperimentMap) {
      Object.values(optimizeExperimentMap)
        .filter((exp) => exp)
        .forEach((experimentId) => {
          window.gtag('event', 'optimize.callback', {
            name: experimentId,
            callback: setOptimizePageId,
          })
        })
    }
  }, [dispatch, optimizeExperimentMap])
}
